// extracted by mini-css-extract-plugin
export default {"ComponentHolder":"MenuTitle_ComponentHolder__GFfM3","backIcon":"MenuTitle_backIcon__De7We"};